// core version + navigation, pagination modules:
import WebXSwiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";
// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

document.addEventListener("DOMContentLoaded", function () {
    //if screenwidth bigger than 768px return
    if (window.innerWidth > 1600 || window.innerWidth < 768) {
        return;
    }
    generateCompetenceGridSwiper();
});

const competenceFields = document.querySelectorAll(".competence-container");
competenceFields.forEach((competenceField) => {
    competenceField.addEventListener("click", function () {
        //check if element is in top or bottom half of the screen
        const rect = competenceField.getBoundingClientRect();
        const topHalf = rect.top + rect.height / 2 < window.innerHeight / 2;
        if (topHalf) {
            competenceField.classList.add("show-bottom");
        }
        //if not yet active, prevent default
        if (competenceField.classList.contains("active")) {
            return;
        } else {
            event.preventDefault();
        }

        //add class active to the clicked competence field
        competenceField.classList.toggle("active");

        //remove class active from all other competence fields
        competenceFields.forEach((competenceField) => {
            if (competenceField !== this) {
                competenceField.classList.remove("active");
                competenceField.classList.remove("show-bottom");
            }
        });
    });
});
//when mouse leaves the competence grid remove class active from all competence fields
const competenceGrid = document.querySelector(
    ".wp-block-webx-blocks-westcam-competence-grid",
);
competenceGrid.addEventListener("mouseleave", function () {
    competenceFields.forEach((competenceField) => {
        competenceField.classList.remove("active");
    });
});

function generateCompetenceGridSwiper() {
    if (isCompetenceSwiper()) {
        return;
    }
    const competenceGrid = document.querySelector(
        ".wp-block-webx-blocks-westcam-competence-grid",
    );
    const competetenceSwiper = new WebXSwiper(competenceGrid, {
        modules: [Navigation, Autoplay],
        slidesPerView: 2,
        spaceBetween: 20,
        autoplay: {
            delay: 1500,
        },
        //responsive breakpoints
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 5,
                spaceBetween: 40,
            },
        },
        loop: true,
        //set wrapper to .competence-grid and slide to .competence-container
        wrapperClass: "competence-grid",
        slideClass: "competence-container",
        speed: 500,
    });
    competenceGrid.addEventListener("click", function () {
        if (competetenceSwiper && competetenceSwiper.autoplay) {
            competetenceSwiper.autoplay.stop();
        }
    });
}

function isCompetenceSwiper() {
    const competenceGrid = document.querySelector(
        ".wp-block-webx-blocks-westcam-competence-grid",
    );
    if (competenceGrid.swiper) {
        return true;
    }
    return false;
}

//check if windows is resized and if it is bigger than 768px destroy the swiper
let resizeTimer;

window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
        if (window.innerWidth > 1600 || window.innerWidth < 768) {
            if (isCompetenceSwiper()) {
                const competenceGrid = document.querySelector(
                    ".wp-block-webx-blocks-westcam-competence-grid",
                );
                competenceGrid.swiper.destroy();
            }
        } else {
            generateCompetenceGridSwiper();
        }
    }, 1500);
});
